import {analytics} from '@shopify/marketing-assets';

import {TweetBuilder} from './tweet-builder';

export class Tweetable {
  constructor(element) {
    this.element = element;
    this.tweetUrl = null;

    this.element.addEventListener('click', this.launchTweetWindow.bind(this));
  }

  buildTweet() {
    const builder = new TweetBuilder(this.element.textContent);

    const urls = this.element.getAttribute('data-tweet-urls');
    const mentions = this.element.getAttribute('data-tweet-mentions');
    const hashtags = this.element.getAttribute('data-tweet-hashtags');

    return builder.build(urls, mentions, hashtags);
  }

  launchTweetWindow(event) {
    event.preventDefault();

    if (!this.tweetUrl) {
      this.tweetUrl = this.encodeTweetURL(this.buildTweet());
    }

    this.track();

    return window.open(this.tweetUrl);
  }

  /**
   * @access private
   */
  track() {
    analytics.track('Tweet link', 'Click', window.location.href);
  }

  /**
   * @access private
   */
  encodeTweetURL(tweet) {
    return `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweet)}`;
  }
}
